import $ from 'jquery';  
window.jQuery = $; window.$ = $;

import '../node_modules/jquery/dist/jquery.js';
import '../node_modules/bodymovin/build/player/bodymovin.js';
import '../node_modules/lottie-web/build/player/lottie.js';
import UIkit from '../node_modules/uikit/dist/js/uikit.js';
import Icons from '../node_modules/uikit/dist/js/uikit-icons.js';

UIkit.use(Icons);

$(function() {
    //Double click to open top level menu item
	$('.uk-offcanvas-bar .uk-parent > a').on('click', function (e) {
		if ($(this).parent().hasClass('uk-open')) {
			window.location = $(this).attr('href');
		}
	});

	if (getCookie('newsletter') == null){
		$('#newsletter-sign-up-overlay').css('display', 'block');
	}

	$('a[href$="/?doLogout=yes"]').on('click', function (e) {
		// sessionStorage.removeItem('data');
    });

	$('#newsletter-sign-up-no').on('click', function (e) {
		$(this).closest('#newsletter-sign-up-overlay').css('display', 'none');
		createCookie("newsletter","no-signup",1);
	});

    // if (getCookie('DetailsModal') == null){
	// 	$('#payment-details-overlay').css('display', 'block');
	// }

    // $('#payment-details-no').on('submit', function (e) {
	// 	$(this).closest('#payment-details-overlay').css('display', 'none');
	// 	createCookie("DetailsModal","dismissed",1);
	// });

    //Prev/Next Titles on Slideshow
	$('.uk-slidenav-previous').prop('title', 'Previous');
	$('.uk-slidenav-next').prop('title', 'Next');

	var loadWin = $(this);
	if (loadWin.width() > 960) { 
		$('.boundary').addClass('bound');
	}

	if (window.location.hash.substring(1)) {
		var i = window.location.hash.substring(1);
		$("#" + i).trigger("click");
	}

	//Events Switcher
	$(".switch").on("click", function() {
		history.replaceState(null, null, $(this).attr("href"))
	});

	$('.item-40').after('<li><a href="/why-you-should-join/more-for-members/wash-and-go">Wash &amp; Go</a></li>');
	$('.item-77').after('<li><a href="/why-you-should-join/more-for-members/wash-and-go">Wash &amp; Go</a></li>');
	
	$('.uk-alert').delay(2000).fadeOut(800); 
});

$(window).on('resize', function(){
	var winResize = $(this);
	if (winResize.width() > 960) { 
	$('.boundary').addClass('bound');
	} else {
	  $('.boundary').removeClass('bound');
	}
});

// Preserve height of slideshow by the size of mega menu
$(window).on('load', function () {
    var preSlideHeight = $('.ujcontainer').outerHeight();
    $('.match-height').css({
        'height': preSlideHeight + 'px'
    });

    $(window).on('resize', function(){
		var slideHeight = $('.ujcontainer').outerHeight();
		$('.match-height').css({
			'height': slideHeight + 'px'
		});
    }).trigger('resize');

    $('#loader').fadeOut("fast");
});


function createCookie(name,value,days) {
    if (days) {
      var date = new Date();
      date.setTime(date.getTime()+(days*24*60*60*1000));
      var expires = "; expires="+date.toGMTString();
    }
    else var expires = "";
    document.cookie = name+"="+value+expires+"; path=/";
}

function getCookie(name) {
    var dc = document.cookie;
    var prefix = name + "=";
    var begin = dc.indexOf("; " + prefix);
    if (begin == -1) {
        begin = dc.indexOf(prefix);
        if (begin != 0) return null;
    }
    else
    {
        begin += 2;
        var end = document.cookie.indexOf(";", begin);
        if (end == -1) {
        end = dc.length;
        }
    }
    return decodeURI(dc.substring(begin + prefix.length, end));
} 


$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
};

$(function(){
    $(window).on('scroll', function() {
        $('.animation-container').each(function() {
            if ($(this).isInViewport()) {
                // only load and play if the animation has not been loaded yet.
                if (!$(this).hasClass('active')) {
                    $(this).addClass('active');

                    var hoverId = $(this).attr('id');    

                    let hoverIcon = document.querySelector('#' + hoverId);

                    var aniIcon = $('#' + hoverId + '>' + '.animation-icon').attr('id');

                    let animation = bodymovin.loadAnimation({
                        container: hoverIcon,
                        renderer: 'svg',
                        loop: false,
                        autoplay: true,
                        path: '/assets/animations/' + aniIcon + '/json/' + aniIcon + '.json'
                    });

                    var directionMenu = 1;
                        hoverIcon.addEventListener('mouseenter', (e) => {
                        animation.setDirection(directionMenu);
                        animation.goToAndPlay(0);
                    });

                    hoverIcon.addEventListener('mouseleave', (e) => {
                        animation.setDirection(-directionMenu);
                        animation.play();
                    });
                }
            }
        })
    })
    $('.animation-container').each(function() {
        if ($(this).isInViewport()) {
            $("html,body").scrollTop(5).scrollTop(0);
        }
    })
});